import React, { useEffect, useRef, useState } from "react";
import { Message } from "semantic-ui-react";
import { ResumenVecino } from "../../components/Vecino/ResumenVecino";
import { Derivaciones } from "../../components/Solicitud/Derivaciones";
import { useForm } from "../../hooks/useForm";
import Swal from "sweetalert2";
import { Canales } from "../../components/Otros/Canales";
import {
  camposTematicas,
  crearAntecedentes,
  crearSolicitud,
  listadoTematicas,
} from "../../utils/Datos";
import { Dinamico } from "../../components/Otros/Dinamico";

import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import { LoadingSpinner } from "../../components/Otros/LoadingSpinner";
import { archivoBase64, fechaJava } from "../../utils/Util";
import { validacionRut } from "../../utils/Validaciones";
import SatisfactionSurveyBanner from "../../components/Otros/SatisfactionSurveyBanner";


export const CrearSolicitud = () => {
  const user = useSelector(selectUser);

  const error = localStorage.getItem("error");
  const info = localStorage.getItem("info");
  const exito = localStorage.getItem("exito");
  const archivo1Ref = useRef(null);
  const archivo2Ref = useRef(null);
  const archivo3Ref = useRef(null);
  const [cargando, setcargando] = useState(false);
  const [tematicas, settematicas] = useState(null);
  const [camposDinamicos, setcamposDinamicos] = useState([]);
  const [validado, setValidado] = useState(false);
  const [perfilCompleto, setperfilCompleto] = useState(0);
  const [charCount, setCharCount] = useState(0)
  const [
    formulario,
    handleInputChange,
    resetForm,
    updateValue,
    updateState,
    formValuesErrores,
    validarCampos,
    formValido,
  ] = useForm(
    {
      id_channel_attention: 1,
      id_category_channel: null,
      run: user.user.run.toString().trim(),
      title: "",
      details: "",
      state: "valor",
      //created_date:null,
      created_by:
        user.user.name.toString().trim() +
        " " +
        user.user.lastname.toString().trim(),
      thematics_requests: [],
      archivos: [],
      detail_additional: {},
    },
    {
      title: {
        error: "",
        validaciones: [
          { tipo: "vacio", mensaje: "Debe ingresar el Título de la solicitud" },
        ],
      },
      details: {
        error: "",
        validaciones: [
          {
            tipo: "largo",
            minimo: 50,
            maximo:5000,
            mensaje: "Debe ingresar al menos 50 caracteres",
          },
        ],
      },
      id_category_channel: {
        error: "",
        validaciones: [
          {
            tipo: "vacio",
            mensaje: "Debe seleccionar una Categoría",
          },
        ],
      },
      tematicas: {
        error: "",
        validaciones: [
          {
            tipo: "largoArreglo",
            minimo: 1,
            mensaje: "Seleccione al menos una temática",
          },
        ],
      },
    }
  );

  const handleCountChange = (e) => {
    const { name, value } = e.target;
    handleInputChange(e); // Manejador de formulario original
    setCharCount(value.length); // Actualizar el contador de caracteres
  };

  useEffect(() => {
    if (user != null) {
      setperfilCompleto(user.user.perfil_completo);
      if (user.user.perfil_completo != 1) {
        window.location.href = "/completarPerfil?causa=datos-incompletos";
      }
    }
  }, [user]);

  useEffect(() => {
    if (validado) validarCampos();
  }, [formulario]);

  useEffect(() => {
    console.log("se cambió la categoría");

    if (formulario.id_category_channel != null) {

      listadoTematicas(formulario.id_category_channel).then((respuesta) => {
        if (respuesta.status) {
          updateValue("thematics_requests", []);
          settematicas(respuesta.datos);
        }
      });
    } else {
      settematicas(null);
    }
  }, [formulario.id_category_channel]);

  const documentoHandler = async (event, nombre, index, ref) => {
    if (event.target.files[0].size > 10000000) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Los archivos no pueden superar los 10MB",
      });
      ref.current.value = null;
    } else {
      let base64 = await archivoBase64(event.target.files[0]);
      let archivo_formateado = {
        name_antecedent: event.target.files[0].name,
        content_byte: base64.split("base64,")[1],
      };
      updateValue(nombre, archivo_formateado, index);
    }
  };

  const handleChangeTematica = (e) => {
    const { value, checked } = e.target;
    const nombreTematica = e.target.getAttribute("data-nombre");

    console.log("Clicks ", value, checked);
    if (checked) {
      console.log("Nueva tematicas +: ", [
        ...formulario.thematics_requests,
        value,
      ]);
      updateValue("thematics_requests", [
        ...formulario.thematics_requests,
        value,
      ]);
      camposTematicas(value).then((resultado) => {
        if (resultado.status) {
          if (resultado.datos.length > 0) {
            console.log("campos", resultado.datos);

            let campos_pintar = [];

            resultado.datos.sort((a, b) => a.order_field - b.order_field);

            resultado.datos.map((element, index) => {
              let existe_campo = buscarCampo(element.field_name);
              console.log("existe? ",element.field_name,existe_campo);
              if (!existe_campo) {
                resultado.datos[index].value = "";
                resultado.datos[index].error = "";
                campos_pintar.push(resultado.datos[index]);
              }
            });
            const dinamicosTemp = [...camposDinamicos];
            // Agregar la nueva temática al estado
            dinamicosTemp.push({
              tematica_id: value,
              tematica_nombre: nombreTematica,
              campos: campos_pintar,
            });
            setcamposDinamicos(dinamicosTemp);
          }
        }
      });
    } else {
      console.log(
        "Nueva tematicas -: ",
        formulario.thematics_requests.filter((e) => e !== value)
      );
      updateValue(
        "thematics_requests",
        formulario.thematics_requests.filter((e) => e !== value)
      );
      const nuevosCampos = camposDinamicos.filter(
        (tematica) => tematica.tematica_id !== value
      );

      // Actualizar el estado con el nuevo arreglo
      setcamposDinamicos(nuevosCampos);
    }
  };

  const handleEnviar = async () => {
    setcargando(true);
    const valido = await validarCampos();
    setValidado(true);
    if (valido && validarCamposDinamicos()) {
      const dinamicosFinal = {};
      camposDinamicos.map((t, index) => {
        t.campos.map((campo, i_campo) => {
          dinamicosFinal[campo.field_name] = campo.value;
        });
      });

      updateState([
        {
          name: "detail_additional",
          value: dinamicosFinal,
        },
        /*{
          name:"created_date",
          value:fechaJava()
        },*/
      ]);

      console.log("dinamicosFinal", dinamicosFinal);
      console.log("form", formulario);
      //jarys updatestate

      let payload = { ...formulario }; //copia del objeto
      payload.id_channel_attention = 1;
      //quittar los archivos antes de enviar la creación
      delete payload.archivos;
      crearSolicitud(payload).then((respuesta) => {
        setcargando(false);
        if (respuesta.status) {
          let neighbour_id = respuesta.datos.id_request_neighbor;
          //created_by
          //id_request_neighbor
          let sumario = "";
          let payload_archivo = [];
          formulario.archivos.map((archivo, index) => {
            let temp_archivos = archivo;
            temp_archivos["id_request_neighbor"] =
              respuesta.datos.id_request_neighbor;
            temp_archivos["created_by"] =
              user.user.name.toString().trim() +
              " " +
              user.user.lastname.toString().trim();

            payload_archivo.push(temp_archivos);
          });

          if (payload_archivo != []) {
            crearAntecedentes(payload_archivo).then((r) => {
              if (!r.status) {
                sumario += `Error al subir los archivos`;
              }
            });
          }

          if (sumario != "") {
            Swal.fire({
              icon: "warning",
              title: "Atención",
              text:
                "La solicitud se ingresó pero hubo un problema al subir uno o más archivos: " +
                sumario,
            }).then((okay) => {
              if (okay) {
                window.location.href = "/home";
              }
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Correcto",
              text: "Solicitud ingresada con éxito",
            }).then((okay) => {
              if (okay) {
                window.location.href = "/home";
              }
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Ha ocurrido un error",
            text: respuesta.errores[0],
          }).then((okay) => {
            if (okay) {
            }
          });
        }
      });
    } else {
      console.log("algo le falta");
      console.log("form", formulario);
      console.log("campos_dinamicos", camposDinamicos);
      setcargando(false);
    }
  };

  const actualizarValorCampo = (tematicaId, campoId, nuevoValor) => {
    // Copia el estado actual para no modificarlo directamente
    const nuevoCamposDinamicos = [...camposDinamicos];

    // Encuentra el objeto con la tematica_id especificada
    const objetoTematica = nuevoCamposDinamicos.find(
      (tematica) => tematica.tematica_id === tematicaId
    );

    // Si se encuentra el objeto de tematica_id, actualiza el valor del campo
    if (objetoTematica) {
      const campoAActualizar = objetoTematica.campos.find(
        (campo) => campo.id_definition_form === campoId
      );

      if (campoAActualizar) {
        campoAActualizar.value = nuevoValor;
        console.log(nuevoCamposDinamicos);
        setcamposDinamicos(nuevoCamposDinamicos);
      }
    }
  };

  const buscarCampo = (nombre) => {
    let existe = false;

    camposDinamicos.map((tematica, index) => {
      tematica.campos.map((campo, i_campo) => {

        if (campo.field_name.trim() == nombre.trim()) {

          existe=true;
        }
      });
    });
    return existe;
  };

  const obtenerValorCampo = (nombre) => {
    let val = "";
    camposDinamicos.map((tematica, index) => {
      tematica.campos.map((campo, i_campo) => {
        if (campo.field_name == nombre) {
          console.log(nombre);
          val = campo.value;
        }
      });
    });
    return val;
  };

  const actualizarErrorCampo = (tematicaId, campoId, nuevoValor) => {
    // Copia el estado actual para no modificarlo directamente
    const nuevoCamposDinamicos = [...camposDinamicos];

    // Encuentra el objeto con la tematica_id especificada
    const objetoTematica = nuevoCamposDinamicos.find(
      (tematica) => tematica.tematica_id === tematicaId
    );

    // Si se encuentra el objeto de tematica_id, actualiza el valor del campo
    if (objetoTematica) {
      const campoAActualizar = objetoTematica.campos.find(
        (campo) => campo.id_definition_form === campoId
      );

      if (campoAActualizar) {
        campoAActualizar.error = nuevoValor;
        setcamposDinamicos(nuevoCamposDinamicos);
      }
    }
  };

  const validarCamposDinamicos = () => {
    /**SETEAR ERRORES EN BLANCO */
    camposDinamicos.map((tematica, index) => {
      tematica.campos.map((campo, i_campo) => {
        actualizarErrorCampo(
          tematica.tematica_id,
          campo.id_definition_form,
          ""
        );
      });
    });

    let valido = true;
    camposDinamicos.map((tematica, index) => {
      tematica.campos.map((campo, i_campo) => {
        if (campo.is_required) {
          let error='';
          if (campo.value == null || campo.value == "") {
            valido = false;
            error = "Este campo no puede estar vacío";
            actualizarErrorCampo(
              tematica.tematica_id,
              campo.id_definition_form,
              error
            );
          }else{
            //validar campo segun sus validaciones
            const validacion=campo.field_validation;
            if (validacion!=null && validacion != "") {
                switch (validacion) {
                  case 'validacion_rut':
                    valido=validacionRut(campo.value);
                    error='El rut ingresado no es válido';
                  break;

                  default:
                    break;
                }
                //actualizar el error
                if (valido==false) {
                  actualizarErrorCampo(
                    tematica.tematica_id,
                    campo.id_definition_form,
                    error
                  );
                }
            }
          }
        }
      });
    });
    return valido;
  };

  return (
    <div className="container post">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <ResumenVecino></ResumenVecino>
            </div>
          </div>

          <SatisfactionSurveyBanner></SatisfactionSurveyBanner>
     
          <div className="card mt-5">
            <div className="card-body">
              <h1 className="text-gray-700 mb-md-0">Crear nueva solicitud</h1>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-8">
                  <label className="form-label fs-6 fw-bold text-gray-700 mb-3">
                    Título de la Solicitud
                  </label>
                  <div className="mb-5">
                    <input
                      type="text"
                      className="form-control  "
                      placeholder=""
                      name="title"
                      value={formulario.title}
                      onChange={handleInputChange}
                    />
                    {formValuesErrores.title.error}
                  </div>
                </div>
                <div className="col-md-4 mt-5 mt-md-0">
                  <label className="form-label fs-6 fw-bold text-gray-700 mb-3">
                    Adjuntar archivos - Máximo 10MB
                  </label>
                  <div className="mb-5">
                    <input
                      type="file"
                      ref={archivo1Ref}
                      className="form-control   mb-2"
                      name="archivo"
                      onChange={(e) =>
                        documentoHandler(e, "archivos", 0, archivo1Ref)
                      }
                    />
                    {formulario.archivos[1] != null ||
                    formulario.archivos[0] != null ? (
                      <input
                        type="file"
                        ref={archivo2Ref}
                        className="form-control   mb-2"
                        name="archivo"
                        onChange={(e) =>
                          documentoHandler(e, "archivos", 1, archivo2Ref)
                        }
                      />
                    ) : (
                      <></>
                    )}
                    {formulario.archivos[2] != null ||
                    formulario.archivos[1] != null ? (
                      <input
                        type="file"
                        ref={archivo3Ref}
                        className="form-control   mb-2"
                        name="archivo"
                        onChange={(e) =>
                          documentoHandler(e, "archivos", 2, archivo3Ref)
                        }
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="mt-4 col-12">
                  <label className="form-label fs-6 fw-bold text-gray-700 mb-3">
                    Detalle de la Solicitud
                  </label>
                  <textarea
                    name="details"
                    value={formulario.details}
                    onChange={(e) =>{
                      handleInputChange(e);
                      handleCountChange(e);
                    }}
                    className="form-control  "
                    rows="8"
                    placeholder=""
                  ></textarea>
                  {formValuesErrores.details.error}

                  {/* Mostramos el contador de caracteres */}
                  <br/>
                  <small className={`text-${charCount >= 50 && charCount <= 5000 ? 'success' : 'danger'}`}>
                    {charCount} / 5000 caracteres (mínimo 50)
                  </small>

                </div>
              </div>
              <div className="row mt-8">
                <div className="col-md-4">
                  <label className="form-label fs-6 fw-bold text-gray-700 mb-3">
                    Categoría
                  </label>
                  <div className="mb-5">
                    <Canales
                      name="id_category_channel"
                      value={formulario.id_category_channel}
                      updateState={updateState}
                      settematicas={settematicas}
                      setcamposDinamicos={setcamposDinamicos}
                    ></Canales>
                    {formValuesErrores.id_category_channel.error}
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-8">
                  <label className="form-label fs-6 fw-bold text-gray-700 mb-3">
                    Temática
                  </label>
                  <div className="row">
                    {tematicas != null ? (
                      tematicas.map((x, i) => (
                        <div
                          className="col-sm-6 col-md-4 mb-5"
                          key={`option${i}`}
                        >
                          <div className="form-check form-check-custom form-check-solid">
                            <input
                              className="form-check-input me-3"
                              name="tematicas"
                              data-nombre={x.name_thematic}
                              type="checkbox"
                              onChange={handleChangeTematica}
                              value={x.id_thematic}
                              id={`tematica-check-${i}`}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`tematica-check-${i}`}
                            >
                              <div className="fw-bold">{x.name_thematic}</div>
                            </label>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>Primero selecciona una categoría</p>
                    )}
                  </div>
                  {formValuesErrores.tematicas.error}
                </div>
                <div className="col-md-12">
                  <div className="row">
                    {camposDinamicos != [] && camposDinamicos != null ? (
                      <>
                        {camposDinamicos.map((element, index) => {
                          if (element.campos.length > 0) {
                            return element.campos.map((campo, indice) => {
                              return (
                                <div
                                  className={`col-md-${
                                    campo.number_columns != null
                                      ? campo.number_columns
                                      : "12"
                                  } mt-4 mb-2`}
                                >
                                  <div className="form-group">
                                    <label
                                      className={
                                        campo.is_required
                                          ? "form-label fs-6 fw-bold text-gray-700 mb-3 required"
                                          : "form-label fs-6 fw-bold text-gray-700 mb-3"
                                      }
                                    >
                                      {campo.alias_field != null
                                        ? campo.alias_field
                                        : campo.field_name}
                                    </label>
                                    <Dinamico
                                      key={campo.id_definition_form}
                                      campo={campo}
                                      className="form-control  "
                                      onChange={(e) => {
                                        console.log(campo);
                                        if (campo.field_type == "checkbox") {
                                          console.log(
                                            "value is",
                                            obtenerValorCampo(campo.field_name)
                                          );
                                          let valorActual = obtenerValorCampo(
                                            campo.field_name
                                          );
                                          if (e.target.checked) {
                                            if (valorActual != "") {
                                              valorActual +=
                                                ";" + e.target.value;
                                            } else {
                                              valorActual = e.target.value;
                                            }

                                            console.log(valorActual);
                                            actualizarValorCampo(
                                              element.tematica_id,
                                              campo.id_definition_form,
                                              valorActual
                                            );
                                          }else {
                                            let buscarEnArray =
                                              valorActual.split(";");
                                            let nuevoValorArr =
                                              buscarEnArray.filter(
                                                (v) => v !== e.target.value
                                              );
                                            let nuevoValorStr =
                                              nuevoValorArr.join(";");
                                            actualizarValorCampo(
                                              element.tematica_id,
                                              campo.id_definition_form,
                                              nuevoValorStr
                                            );
                                          }
                                        } else if (campo.field_type == "mapa") {
                                          console.log("EL MAPA",e)
                                            actualizarValorCampo(
                                              element.tematica_id,
                                              campo.id_definition_form,
                                              `${e.latlng.lat},${e.latlng.lng},${e.address}`
                                            );
                                        } else {
                                          actualizarValorCampo(
                                            element.tematica_id,
                                            campo.id_definition_form,
                                            e.target.value
                                          );
                                        }
                                      }}
                                    />
                                    <small
                                      className="text-danger"
                                      id={`error_${campo.id_definition_form}`}
                                    >
                                      {campo.error}
                                    </small>
                                  </div>
                                </div>
                              );
                            });
                          }
                        })}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="col-md-12 mt-5 mt-md-0 text-end">
                  {cargando ? (
                    <LoadingSpinner
                      texto={"Enviando solicitud, espere un momento..."}
                    ></LoadingSpinner>
                  ) : (
                    <button
                      className="btn btn-primary"
                      onClick={() => handleEnviar()}
                    >
                      Crear Solicitud
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
